import { enforce, omitWhen, test } from 'vest';

import {
  isEndpointUrl,
  withDefaults,
} from 'admin-panel/utils/integrations/config';

import type { IntegrationConfig } from 'admin-panel/models/integrations/configuration';
import type {
  IntegrationFormValues,
  ServiceFormDefinition,
} from 'admin-panel/utils/integrations/types';

export interface MaxxtonService {
  apiEndpointUrl: string;
  clientId: string;
  clientSecret: string;
  concernCode: string;
}

const SERVICE = 'currentConfig.service';

const defaultConfig = (): IntegrationConfig => ({
  service: {
    apiEndpointUrl: '',
    clientId: '',
    clientSecret: '',
    concernCode: '',
  },
  features: {},
  cron: [],
  webhooks: [],
});

export const maxxton: ServiceFormDefinition = {
  toFormConfig: (config) => withDefaults(defaultConfig(), config),

  validate(values: IntegrationFormValues, t) {
    const service = values.currentConfig.service as unknown as MaxxtonService;

    test(`${SERVICE}.apiEndpointUrl`, t('validations.required'), () => {
      enforce(service.apiEndpointUrl).isNotBlank();
    });

    omitWhen(!service.apiEndpointUrl, () => {
      test(`${SERVICE}.apiEndpointUrl`, t('validations.url'), () => {
        enforce(isEndpointUrl(service.apiEndpointUrl)).isTruthy();
      });
    });

    for (const field of ['clientId', 'clientSecret', 'concernCode'] as const) {
      test(`${SERVICE}.${field}`, t('validations.required'), () => {
        enforce(service[field]).isNotBlank();
      });
    }
  },
};
